import { render } from "./CollectorsPage.vue?vue&type=template&id=3dc6dd8b&scoped=true&ts=true"
import script from "./CollectorsPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./CollectorsPage.vue?vue&type=script&lang=ts&setup=true"

import "./CollectorsPage.vue?vue&type=style&index=0&id=3dc6dd8b&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dc6dd8b"],['__file',"src/pages/settings/pages/collectors/CollectorsPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3dc6dd8b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3dc6dd8b', __exports__)) {
    api.reload('3dc6dd8b', __exports__)
  }
  
  module.hot.accept("./CollectorsPage.vue?vue&type=template&id=3dc6dd8b&scoped=true&ts=true", () => {
    api.rerender('3dc6dd8b', render)
  })

}


export default __exports__